import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';

export const IconMagnifierSearchGroup: React.FC<SvgProps> = (props) => {
  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M1.26758 7.96401C1.26758 9.47479 1.86774 10.9237 2.93602 11.992C4.00431 13.0603 5.45322 13.6604 6.96401 13.6604C8.47479 13.6604 9.9237 13.0603 10.992 11.992C12.0603 10.9237 12.6604 9.47479 12.6604 7.96401C12.6604 6.45322 12.0603 5.00431 10.992 3.93602C9.9237 2.86774 8.47479 2.26758 6.96401 2.26758C5.45322 2.26758 4.00431 2.86774 2.93602 3.93602C1.86774 5.00431 1.26758 6.45322 1.26758 7.96401Z"
        fill="#F9F5FF"
      />
      <path
        d="M1.26758 7.96401C1.26758 9.47479 1.86774 10.9237 2.93602 11.992C4.00431 13.0603 5.45322 13.6604 6.96401 13.6604C8.47479 13.6604 9.9237 13.0603 10.992 11.992C12.0603 10.9237 12.6604 9.47479 12.6604 7.96401C12.6604 6.45322 12.0603 5.00431 10.992 3.93602C9.9237 2.86774 8.47479 2.26758 6.96401 2.26758C5.45322 2.26758 4.00431 2.86774 2.93602 3.93602C1.86774 5.00431 1.26758 6.45322 1.26758 7.96401Z"
        fill="#696D70"
        stroke="#696D70"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.1016 12.1016L14.2139 15.2139"
        stroke="#696D70"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.09082 9.92687L5.78002 7.59178L8.24785 8.63512L9.83769 6.00195"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const IconMagnifierSearchSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      {...(props.svg ?? {})}
    >
      <IconMagnifierSearchGroup {...props} />
    </svg>
  );
};
